module.exports = __webpack_public_path__ + "img/puzzle.61c488df.svg";